import * as React from 'react';
const ModalSetContext = React.createContext({ setId: 0 });
export default ModalSetContext;
